import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


function pathViewEasyStoreSettingsShforms() {
  return `view/easystore-settings-shforms`;
}

export function getViewEasyStoreSettingsShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewEasyStoreSettingsShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathEasyStoreSettings() {
  return `easystore-settings`;
}

export function patchEasyStoreSettings(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathEasyStoreSettings(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}
